/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { presignedUrlTrackModelSchema } from "./presignedUrlTrackModelSchema.ts";
import { z } from "zod";

export const multiUploadTracksModelSchema = z.object({
    "files": z.object({
    
    }).catchall(z.lazy(() => presignedUrlTrackModelSchema)).describe("Словарь файлов").nullable().nullish()
    })